import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { App } from './App';
import { SellersPage } from './pages/Sellers';
import { BuyersPage } from './pages/Buyers';
import { MarketingPage } from './pages/Marketing';
import { AboutPage } from './pages/About';
import { ContactPage } from './pages/Contact';
import { ScrollToTop } from './components/ScrollToTop';
export function AppRouter() {
  return <BrowserRouter data-id="element-16">
      <ScrollToTop data-id="element-17" />
      <AnimatePresence mode="wait" data-id="element-18">
        <Routes data-id="element-19">
          <Route path="/" element={<App data-id="element-21" />} data-id="element-20" />
          <Route path="/services/sellers" element={<SellersPage data-id="element-23" />} data-id="element-22" />
          <Route path="/services/buyers" element={<BuyersPage data-id="element-25" />} data-id="element-24" />
          <Route path="/services/marketing" element={<MarketingPage data-id="element-27" />} data-id="element-26" />
          <Route path="/about" element={<AboutPage data-id="element-29" />} data-id="element-28" />
          <Route path="/contact" element={<ContactPage data-id="element-31" />} data-id="element-30" />
        </Routes>
      </AnimatePresence>
    </BrowserRouter>;
}